import {
  ACTIVITY_STATE__COMPLETED,
  ACTIVITY_STATE__ACTIVE,
  ACTIVITY_STATE__ABORTED,
  ACTIVITY_STATE__CANCELED,
  ACTIVITY_STATE__EXPIRED,
  ACTIVITY_STATE__SCHEDULED,
  ACTIVITY_STATE__PLANNED,
  ACTIVITY_STATE__OMITTED,
  ACTIVITY_STATE__SUSPENDED,
} from '../../../../common/constants';

const disabledClassName = 'opacity-50';

export const getEventBackgroundColor = (
  type,
  isEmpty,
  isNonActionable,
  isDisabled,
) => {
  let className = isNonActionable ? 'bg-surface text-on-surface' : '';

  switch (type) {
    case 'success':
      className += isNonActionable
        ? ''
        : `bg-success text-on-success ${
            isDisabled ? disabledClassName : 'group-hover:bg-success-muted'
          }`;
      break;
    case 'danger':
      className += isNonActionable
        ? ''
        : `bg-danger text-on-danger ${
            isDisabled ? disabledClassName : 'group-hover:bg-danger-muted'
          }`;
      break;
    case 'warning':
      if (isEmpty) {
        className += isNonActionable
          ? ''
          : `bg-neutral text-on-neutral ${
              isDisabled ? disabledClassName : 'group-hover:bg-neutral-muted'
            }`;
        break;
      }

      className += isNonActionable
        ? ''
        : `bg-warning text-on-warning ${
            isDisabled ? disabledClassName : 'group-hover:bg-warning-muted'
          }`;
      break;
    case 'info':
      className += isNonActionable
        ? ''
        : `bg-info text-on-info ${
            isDisabled ? disabledClassName : 'group-hover:bg-info-muted'
          }`;
      break;
    default:
      className += isNonActionable
        ? ''
        : `bg-neutral text-on-neutral ${
            isDisabled ? disabledClassName : 'group-hover:bg-neutral-muted'
          }`;
  }

  return className;
};

export const getEventBorderColor = (type, isEmpty, isDisabled) => {
  switch (type) {
    case 'success':
      return `border-success ${
        isDisabled ? disabledClassName : 'group-hover:border-success-muted'
      }`;
    case 'danger':
      return `border-danger ${
        isDisabled ? disabledClassName : 'group-hover:border-danger-muted'
      }`;
    case 'warning':
      if (isEmpty) {
        return `border-neutral ${
          isDisabled ? disabledClassName : 'group-hover:border-neutral-muted'
        }`;
      }

      return `border-warning ${
        isDisabled ? disabledClassName : 'group-hover:border-warning-muted'
      }`;
    case 'info':
      return `border-info ${
        isDisabled ? disabledClassName : 'group-hover:border-info-muted'
      }`;
    default:
      return `border-neutral ${
        isDisabled ? disabledClassName : 'group-hover:border-neutral-muted'
      }`;
  }
};

export const getMilestoneStatus = (t, state, isEmpty) => {
  switch (state) {
    case ACTIVITY_STATE__COMPLETED:
      return t('components:Milestone.completed');
    case ACTIVITY_STATE__EXPIRED:
      return t('components:Milestone.incomplete');
    case ACTIVITY_STATE__ACTIVE:
      if (isEmpty) {
        return t('components:Milestone.empty');
      }

      return t('components:Milestone.due');
    case ACTIVITY_STATE__SCHEDULED:
    case ACTIVITY_STATE__PLANNED:
      return t('components:Milestone.upcoming');
    case ACTIVITY_STATE__CANCELED:
    case ACTIVITY_STATE__ABORTED:
      return t('components:Milestone.inactive');
    case ACTIVITY_STATE__SUSPENDED:
      return t('components:Milestone.suspended');
    case ACTIVITY_STATE__OMITTED:
      return t('components:Milestone.omitted');
    default:
      return t('components:Milestone.custom');
  }
};
